import { useState, useEffect } from "react";
import emailjs from "@emailjs/browser"
import "../styles/style.css";
import Title from "./Title";

import { useTranslation } from "react-i18next"



export default function SectionSeven() {

    const { t } = useTranslation();

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });

    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);


    useEffect(() => {

        if (!error) return;

        const timer = setTimeout(() => {
            setError("");
        }, 3000);

        return () => clearTimeout(timer);

    }, [error]);

    useEffect(() => {

        if (!success) return;

        const timer = setTimeout(() => {
            setSuccess("");
        }, 3000);

        return () => clearTimeout(timer);

    }, [success]);



    const handleChange = (e) => {

        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        if (error) {

            setError("");

        }

    };


    const handleReset = () => {
        setFormData({
            name: "",
            email: "",
            message: "",
        });

        setError("");
        setSuccess("");
    };

    const validate = () => {

        if (
            !formData.name.trim() ||
            !formData.email.trim() ||
            !formData.message.trim()
        ) {
            return t("fill-forme.text");
        }

        const emailRegex =
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(formData.email)) {
            return "Please enter a valid email";
        }

        if (formData.name.trim().length < 2) {
            return "Name is too short";
        }

        if (formData.message.trim().length < 10) {
            return t("short-message.text");
        }

        return "";
    };



    const handleSubmit = async (e) => {

        e.preventDefault();

        const validationError = validate();

        if (validationError) {
            setError(validationError);
            setSuccess("");
            setTimeout(() => {

                setSuccess("");

            }, 3000);
            return;
        }

        setLoading(true);

        try {


            await emailjs.send(
                "service_mkqfu1a",
                "template_na77fnl",
                {
                    name: formData.name,
                    email: formData.email,
                    message: formData.message,
                },
                "ie1CR8LG6kTrXvb2j"
            );

            setSuccess(t("sent-success.text"));
            setTimeout(() => {

                setSuccess("");

            }, 3000);

            setError("");

            setFormData({
                name: "",
                email: "",
                message: "",
            });

        } 
        catch (err) {
            console.log(err);
            console.log(err.text);
            console.log(err.status);

            setError("Something went wrong.");
        }
        finally {

            setLoading(false);

        }

    };






    return (
        <section className="section sec-7">
            

            <Title id="contact" title={t("title-contact.text")} />

            <div className="container container-7">
                <div data-aos="fade-right" className="contain-7">

                    <div className="form">
                        <div className="login-box">

                            <h3>{t("title-contact.text")}</h3>

                            <form id="contactForm" onSubmit={handleSubmit}>

                                <div className="input-box">
                                    <input className={`input ${formData.name ? "active" : ""}`} id="name" autoComplete="name" type="text" name="name"  value={formData.name} onChange={handleChange} />
                                    <label htmlFor="name">{t("label.name")}</label>
                                </div>

                                <div className="input-box">
                                    <input className={`input ${formData.email ? "active" : ""}`} id="email" autoComplete="email" type="email" name="email"  value={formData.email} onChange={handleChange} />
                                    <label htmlFor="email">{t("label.email")}</label>
                                </div>

                                <div className="input-box textarea">
                                    <textarea id="message" name="message" placeholder={t("placeholder.text")}  value={formData.message} onChange={handleChange}></textarea>
                                </div>

                            </form>

                        </div>

                        <div className={`form-fill ${error ? "show" : ""}`}>
                            {error}
                        </div>

                    </div>

                    <div className="right">
                        <div className="satelite reset">
                            <button type="button" onClick={handleReset}>
                                {t("reset.text")}
                            </button>
                        </div>

                        <div className="satelite send">
                            <button
                                type="submit"
                                form="contactForm"
                                disabled={loading}
                            >
                                {loading ? t("send-louding.text") : (
                                    <>
                                        {t("send.text")} <i className="fa fa-arrow-circle-right"></i>
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                        
                    
                </div>
                

                {success && (
                    <div className="form-success">
                        {success}
                    </div>
                )}

                <div data-aos="fade-left" className="text-contain-7">
                    <p>{t("contact-text.text")}</p>
                </div>

                <div data-aos="fade-up" className="wrapper-social">
                    <a href="https://www.facebook.com/profile.php?id=100090911228572&mibextid=kFxxJD" target="_blank" rel="noopener noreferrer">
                        <div className="button-social">

                            <div className="icon-social facebook">
                                <i className="fa-brands fa-facebook-f"></i>
                            </div>
                            <span>{t("icons.facebook")}</span>

                        </div>
                    </a>

                    <a href="https://www.linkedin.com/in/mohamed-eltohamy7" target="_blank" rel="noopener noreferrer" >
                        <div className="button-social">
                            <div className="icon-social linkedin">
                                <i className="fa-brands fa-linkedin-in"></i>
                            </div>
                            <span>{t("icons.linkedin")}</span>
                        </div>
                    </a>

                    <a href="https://github.com/Tohamy-521" target="_blank" rel="noopener noreferrer" >
                        <div className="button-social">
                            <div className="icon-social github">
                                <i className="fa-brands fa-github"></i>
                            </div>
                            <span>{t("icons.github")}</span>
                        </div>
                    </a>


                    <a href="https://codepen.io/Mohamed-Eltohamy" target="_blank" rel="noopener noreferrer">
                        <div className="button-social">
                            <div className="icon-social whatsapp">
                                <i className="fa-brands fa-codepen"></i>
                            </div>
                            <span>{t("icons.codepen")}</span>
                        </div>
                    </a>

                    <a href="mailto:info@mohamedeltohamy.com">
                        <div className="button-social">
                            <div className="icon-social mail">
                                <i className="fa-solid fa-envelope"></i>
                            </div>
                            <span>{t("icons.mail")}</span>
                        </div>
                    </a>


                </div>
            </div>
        </section>
    );
}

